import { Link } from "react-router-dom";
import { XCircle, Zap } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[70vh] bg-secondary flex items-center justify-center px-5 pt-28 pb-16">
      <div className="max-w-lg w-full border border-border bg-card p-10 md:p-12 text-center">
        <XCircle size={48} className="text-red-600 mx-auto mb-6" />
        <h1 className="font-display font-black text-3xl mb-3 tracking-tight">Payment Cancelled</h1>
        <p className="text-muted-foreground mb-2">No charge was made.</p>
        <p className="text-muted-foreground mb-8">Your FastTrack request has been received and saved — priority handling activates once the one-time $49 fee is completed.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/fasttrack" data-testid="retry-payment-link"
            className="inline-flex items-center justify-center gap-2 bg-brand-orange text-white px-8 py-4 font-mono uppercase text-[11px] tracking-[0.18em] hover:bg-brand-orangeHover transition-colors">
            <Zap size={14} /> Complete Payment
          </Link>
          <Link to="/"
            className="inline-flex items-center justify-center gap-2 border border-foreground px-8 py-4 font-mono uppercase text-[11px] tracking-[0.18em] hover:bg-foreground hover:text-background transition-colors">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
